import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPaymentSepa = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 24"
    ref={ref}
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#cdd7d6"
      rx={2.5}
    />
    <path
      fill="#10298E"
      d="M7.919 8.536q1.078 0 1.534.123 1.116.3 1.116 1.684 0 .113-.016.34h-1.71q0-.422-.099-.567-.153-.213-.843-.213-.67 0-.886.123-.217.125-.217.537 0 .373.192.49a.8.8 0 0 0 .365.1l.345.024q1.109.074 1.385.103.877.09 1.27.467.311.295.37.772.035.285.035.644 0 .825-.157 1.21-.285.703-1.284.89-.418.078-1.279.079-1.436 0-2.002-.172-.693-.21-.915-.855Q5 13.958 5 13.122h1.71v.143q0 .445.256.573.176.087.428.093h.627q.482 0 .615-.05a.5.5 0 0 0 .31-.3q.038-.128.038-.329 0-.451-.329-.55-.123-.039-1.143-.108a14 14 0 0 1-1.139-.114q-.84-.156-1.12-.647-.245-.418-.245-1.263 0-.643.133-1.03.132-.39.427-.59.433-.31 1.107-.365a14 14 0 0 1 1.244-.049M21.497 8.5q.705 0 1.074.115.844.266 1.135 1.086.15.431.15 1.296 0 1.042-.166 1.497-.33.9-1.354 1.035-.12.021-1.024.035l-.306.011H19.91v1.767h-1.838V8.5zm8.495 6.842H28.13l-.35-1.183h-2.458l-.33 1.183H23.09L25.142 8.5h2.773zm-4.275-2.516h1.697l-.861-2.966zm-5.807-.838h1.146q.544-.018.664-.085.162-.09.218-.359.035-.18.035-.534 0-.434-.07-.644-.099-.294-.475-.36a4 4 0 0 0-.357-.009h-1.16z"
    />
    <path
      fill="#FFBE00"
      fillRule="evenodd"
      d="M15.534 9.462c.759 0 1.435.35 1.88.898l.396-.85a3.47 3.47 0 0 0-2.393-.95 3.44 3.44 0 0 0-3.196 2.117h-.773l-.456.98h.994a3.3 3.3 0 0 0 .005.608h-.5l-.456.98h1.21a3.45 3.45 0 0 0 3.172 2.057 3.5 3.5 0 0 0 1.937-.584v-1.2a2.414 2.414 0 0 1-3.846-.273h2.533l.456-.98h-3.362a2.5 2.5 0 0 1-.014-.608h3.659l.456-.98h-3.799a2.42 2.42 0 0 1 2.097-1.215"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPaymentSepa);
export default ForwardRef;
